import { RepositoryFactory } from "src/api/repositories/RepositoryFactory";
const BlogPostsRepository = RepositoryFactory.get("blogPosts");


const state = {
    blogPosts: [],
    currentPage: 2,
    totalItems: 1,
    totalPages: 4,
    itemsPerPage: 20,
    categories: [],
    searchParams: {},
};

const getters = {
    postSearchParams(p) {
        return state.searchParams;
    },
    blogCataloguePosts(state) {
        return state.blogPosts;
    },
    totalPosts(state) {
        return state.totalItems;
    },
    totalPostPages(state) {
        return state.totalPages;
    },
    currentPostPage(state) {
        return state.currentPage;
    },
    postCategories(state) {
        return state.categories;
    },
    postCategoryList(state) {
        return state.categories.map(obj => obj.name);
    },
};

const mutations = {
    setBlogPosts(state, blogPosts) {
        state.blogPosts = blogPosts.map((b) => ({ ...b, type: "blog_post" }));
    },
    setPaginationData(state, pagination) {
        state.currentPage = pagination.page;
        state.totalItems = pagination.totalItems;
        state.itemsPerPage = pagination.itemsPerPage;
        state.totalPages = pagination.totalPages;
    },
    setCategories(state, categories) {
        state.categories = categories
            .map((cat) => ({ name: cat.category, count: cat.count }))
            .sort((a, b) => a.name.localeCompare(b.name));
    },
    updatePost(state, postData) {
      const postIdx = state.blogPosts.findIndex(post => post.id === postData.id);
      if (postIdx >= 0) {
        state.blogPosts.splice(postIdx, 1, { ...state.blogPosts[postIdx], ...postData }); 
      }
    },
    toggleStatus(state, id) {
      const stateMap = {
        published: "draft",
        draft: "published"
      }
      const post = state.blogPosts.find(post => post.id === id);
      post && (post.access = stateMap[post.access]);
    }
};

const actions = {
    fetchBlogPosts({ commit, state, rootState }, params = { page: 1 }) {
        state.searchParams = params;
        params['site_template'] = true;        
        return BlogPostsRepository.blogPosts(params).then((res) => {
            commit("setBlogPosts", res.data.blogPosts);
            commit("setPaginationData", res.data.pagination);
            commit("setCategories", res.data.blogPostsCategories);
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
